import { render } from "./InsuranceRisksModal.vue?vue&type=template&id=b7186afe"
import script from "./InsuranceRisksModal.vue?vue&type=script&lang=js"
export * from "./InsuranceRisksModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__